import { React, useRef, useState } from 'react'
import { Container, Row, Col, Form, Button, OverlayTrigger, Tooltip,  Modal} from 'react-bootstrap'
import Card from '../../../components/Card'
import { Link, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import ServicesRequest from '../../../service/ServiceRequest'
import ReactLoading from "react-loading";
import Swal from 'sweetalert2'
import { PublicStrings } from '../../../constants/Public-Strings'
import { AgencyString } from '../../../constants/Agency-String'
import { successToast } from '../../../constants/Toasts-Components'





const EnabledUsersOrAgenciesList = ({ enabled_for, product_id, setEnabledFor, all_products, item_type}) => {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    let serviceRequestObj = new ServicesRequest("agency");

    return (
        <>        
            <Card>
                <Card.Body>

                    <div className="d-flex flex-wrap align-items-center justify-content-between my-schedule mb-4">
                        
                        <div className="d-flex align-items-center justify-content-between">
                            <h5 className="font-weight-bold">{item_type === "product" && "Prodotti abilitati:"} {item_type === "campaign" && "Campagne abilitate:"}</h5>
                        </div>

                        <Button variant="primary" onClick={handleShow}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                            </svg>
                            Aggiungi
                        </Button>
                
                        <Modal show={show} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Seleziona il {item_type === "product" ? "prodotto" : item_type === "campaign" ? "campagna" : ""} da abilitare</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                        <table className="table data-table mb-0">
                            <tbody>
                                        <>
                                            {
                                               enabled_for.length >= all_products.length ? 

                                               <i> Tutti i { item_type === "product" ? "prodotti" : item_type === "campaign" ? "campagne" : ""} sono già abilitati </i>
                                                : 

                                                all_products.map((item, index) => ( 
                                                    
                                                    enabled_for.map(user  => user.id).includes(item.id) ? <></> :
                                                        <tr className="white-space-no-wrap" key={index}>

                                                            <td style={{"padding" : "0px" , "borderTop" : "1px"}}>
                                                                <div className="d-flex justify-content-end align-items-center">

                                                                        <button type="button" className="dropdown-item bg-light border rounded btn-block mb-2" onClick={async () => {

                                                                            const response = await serviceRequestObj.toggleEnableProductForUserOrAgency(product_id, item.id, 'agency', true, item_type)
                                                                            if(response !== null){
                                                                                if(response.response){

                                                                                    Swal.fire({
                                                                                        icon: 'error',
                                                                                        title: 'Error',
                                                                                        text: response.response.data.error_message,
                                                                                    })
                                                                                } else{
                                                                                    console.log("Adding stuff");
                                                                                    handleClose();
                                                                                    console.log(enabled_for);
                                                                                    setEnabledFor(values => ([ ...values, item ]))
                                                                                }  
                                                                            }

                                                                        }}>
                                                                            

                                                                            {item.name}
                                                                        </button>
                                 

                                                                </div>
                                                            </td>
                                                         </tr>
                                                    

                                                ))
                                            }
                                        </>
                                
                            </tbody>
                        </table>

                        </Modal.Body>
                        
                        </Modal>

                    </div>

                    
                    
                                
                                <>
                                {
                                    enabled_for.length === 0 ? 

                                        <i> Questo prodotto non è abilitato per nessun utente </i>
                                    :<table className="table data-table mb-0">
                                    <tbody>
                                          
                                        {enabled_for.map((item, index) => ( 
                                            
                                            <tr id={"enabled_row_"+item.id} key={index} className="white-space-no-wrap">

                                                <td> {item.name}</td>

                                                <td>
                                                    <div className="d-flex justify-content-end align-items-center">

                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Remove</Tooltip>} >
                                                            <h6 className="badge bg-danger" onClick={async () => {

                                                                const response = await serviceRequestObj.toggleEnableProductForUserOrAgency(product_id, item.id, 'agency', false, item_type)
                                                                if(response !== null){
                                                                    if(response.response){

                                                                        Swal.fire({
                                                                            icon: 'error',
                                                                            title: 'Error',
                                                                            text: response.response.data.error_message,
                                                                        })
                                                                    } else{
                                                                        console.log("Deleting stuff");
                                                                        setEnabledFor(values => (values.filter(f => f.id !== item.id)));
                                                                        // var row = document.getElementById(`enabled_row_${item.id}`);
                                                                        // row.remove();
                                                                    }  
                                                                }

                                                            }}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                                </svg>
                                                            </h6>
                                                        </OverlayTrigger>

                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                        
                                    
                                }
                                </>
                            
                            
                        

                </Card.Body>
            </Card>

        </>
    )
}

const AgencyAddOrView = (props) => {

    let serviceRequestObj = new ServicesRequest("agency");


    const form = useRef(null);
    const { config } = useSelector((state) => state.auth)

    const [inputs, setInputs] = useState({
        name : '',
        address : '',
        city : '',
        zipcode : '',
        province: '',
        province_symbol: '',
        is_internal_backoffice: false,
        is_institute_backoffice: false
    });

    const [products_enabled_for, setProductsEnabledFor] = useState([]);
    const [campaigns_enabled_for, setCampaignsEnabledFor] = useState([]);

    const [all_products, setAllProducts] = useState([]);
    const [all_campaigns, setAllCampaigns] = useState([]);

    const [loading, setLoading] = useState(false);
   

    const [is_new_product, setIsNewProduct] = useState(true)
    const [product_id, setProductId] = useState("");

    const params = useParams();

    async function fetchAgencyInfo(product_id) {

        setLoading(true);

        const response = await serviceRequestObj.getProductInfo(product_id);
        console.log(response)
        if (!response.response) {

            setProductsEnabledFor(response['products_enabled']);
            setCampaignsEnabledFor(response['campaigns_enabled']);

            setAllProducts(response['all_products']);
            setAllCampaigns(response['all_campaigns']);

            const columns = ['id', 'name', 'address','zipcode','city','province','province_symbol','is_internal_backoffice','is_institute_backoffice']

            for (const key of columns) {
                var value = response[key];
                if (value !== null) {
                    setInputs(values => ({ ...values, [key]: value }))
                }
            }
        }
        setLoading(false);
    }

    

    useEffect(() => {

        setProductId(params.agency_id);
        setIsNewProduct(isNaN(params.agency_id));

        if (params.agency_id) {
            fetchAgencyInfo(params.agency_id);
        }

    }, [])




    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({ ...values, [name]: value }))
    }

    const handleCheckboxChange = (event) => {
        const name = event.target.name;
        const checked = event.target.checked;
        setInputs(values => ({ ...values, [name]: checked }))
    }

    const handleBackofficeTypeChange = (event) => {
        const selectedType = event.target.value;
        
        // Reset both backoffice flags
        const newInputs = {
            ...inputs,
            is_internal_backoffice: false,
            is_institute_backoffice: false
        };
        
        // Set the selected type to true
        if (selectedType !== 'is_agency' && selectedType !== 'none') {
            newInputs[selectedType] = true;
        }
        if (selectedType === 'is_agency') {

        }
        
        setInputs(newInputs);
    }

    // Helper function to get current backoffice type
    const getCurrentBackofficeType = () => {
        if (inputs.is_internal_backoffice) return 'is_internal_backoffice';
        if (inputs.is_institute_backoffice) return 'is_institute_backoffice';
        return 'is_agency';
    }


   

    const submitCreateProduct = async (event) => {

        event.preventDefault();
        setLoading(true);
        const response = await serviceRequestObj.createProduct(inputs);
        console.log(response);
        if (response.response) {

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: response.response.data.error_message,
            })
            
        } else {
            setProductId(response.id);
            setIsNewProduct(false);
            setInputs(values => ({ ...values, "id": response.id }))
            setProductsEnabledFor(response.products_enabled)
            setCampaignsEnabledFor(response.campaigns_enabled);
            setAllProducts(response.all_products)
            setAllCampaigns(response.all_campaigns)
            const editUrl = "/agency-view/" + response.id;
            window.history.replaceState(null, "", editUrl);
            successToast('Agency Added Successfully..')
        }
        setLoading(false)
        
    }


    const submitSaveProduct = async (event) => {
        event.preventDefault();
        setLoading(true);
        const response = await serviceRequestObj.saveProduct(inputs);
        if (response.response) {

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: response.response.data.error_message,
            })

        } else {
            successToast('Update Successfully..')
        }
        setLoading(false)
    }


    return (
        <>
            <Container fluid>
                <Row>
                    <Col lg="12">
                        <div className="d-flex flex-wrap align-items-center justify-content-between">
                            <div className="d-flex align-items-center justify-content-between">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb p-0 mb-0">
                                        <li className="breadcrumb-item">
                                            <Link to={{ pathname: "/agency", state: {}}}> {AgencyString.title} </Link>
                                        </li>

                                        <li className="breadcrumb-item active" aria-current="page">{is_new_product ? AgencyString.addAgency : (config.is_admin? AgencyString.editAgency : AgencyString.viewAgency) }</li>
                                    </ol>
                                </nav>
                            </div>
                            <Link to={{ pathname: "/agency", state: {}}} className="btn btn-primary btn-sm d-flex align-items-center justify-content-between ml-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                                </svg>
                                <span className="ml-2">{PublicStrings.back}</span>
                            </Link>
                        </div>
                    </Col>
                    <Col lg="12" className="mb-3 d-flex justify-content-between">
                        <h4 className="font-weight-bold d-flex align-items-center">{is_new_product ? AgencyString.addAgency : (config.is_admin? AgencyString.editAgency : AgencyString.viewAgency) }</h4>
                    </Col>
                    <Col lg="12">
                        <Card>
                            <Card.Body>
                                {loading && is_new_product === false ? (
                                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
                                        <ReactLoading
                                            type={"spin"}
                                            color={"#007bff"}
                                            height={50}
                                            width={50}
                                        />
                                    </div>
                                ) : (
                                <Form className=" g-3" onSubmit={is_new_product ? submitCreateProduct : submitSaveProduct} ref={form}>
                                    <div className='row'>

                                        <Form.Control type='text' name='id' defaultValue={product_id} hidden />

                                        <div className="col-md-6 mb-3" >
                                            <Form.Label htmlFor='name' className="form-label font-weight-bold text-muted text-uppercase">{AgencyString.name}</Form.Label>
                                            <Form.Control type='text' className="form-control" name='name' placeholder=''
                                                value={inputs["name"]}
                                                onChange={(e)=>handleChange(e)}
                                                required
                                                disabled={!config.is_admin}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3" >
                                            <Form.Label htmlFor='address' className="form-label font-weight-bold text-muted text-uppercase">{AgencyString.address}</Form.Label>
                                            <Form.Control type='text' className="form-control" name='address' placeholder=''
                                                value={inputs["address"]}
                                                onChange={(e)=>handleChange(e)}
                                                required
                                                disabled={!config.is_admin}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <Form.Label htmlFor='city' className="form-label font-weight-bold text-muted text-uppercase">{AgencyString.city}</Form.Label>
                                            <Form.Control type='text' className="form-control" name='city' placeholder=''
                                                value={inputs["city"]}
                                                onChange={(e)=>handleChange(e)}
                                                required
                                                disabled={!config.is_admin}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3" >
                                            <Form.Label htmlFor='zipcode' className="form-label font-weight-bold text-muted text-uppercase">{AgencyString.zipcode}</Form.Label>
                                            <Form.Control type='number' className="form-control" name='zipcode' placeholder=''
                                                value={inputs["zipcode"]}
                                                onChange={(e)=>handleChange(e)}
                                                required
                                                disabled={!config.is_admin}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3" >
                                            <Form.Label htmlFor='province' className="form-label font-weight-bold text-muted text-uppercase">{AgencyString.province}</Form.Label>
                                            <Form.Control type='text' className="form-control" name='province' placeholder=''
                                                value={inputs["province"]}
                                                onChange={(e)=>handleChange(e)}
                                                required
                                                disabled={!config.is_admin}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3" >
                                            <Form.Label htmlFor='province_symbol' className="form-label font-weight-bold text-muted text-uppercase">{AgencyString.province_symbol}</Form.Label>
                                            <Form.Control type='text' className="form-control" name='province_symbol' placeholder=''
                                                value={inputs["province_symbol"]}
                                                onChange={(e)=>handleChange(e)}
                                                required
                                                disabled={!config.is_admin}
                                            />
                                        </div>

                                        <div className="col-md-6 mb-3" >
                                            <Form.Label htmlFor='backoffice_type' className="form-label font-weight-bold text-muted text-uppercase">Tipo Struttura</Form.Label>
                                            <Form.Control 
                                                as="select" 
                                                className="form-control" 
                                                name='backoffice_type'
                                                value={getCurrentBackofficeType()}
                                                onChange={handleBackofficeTypeChange}
                                                disabled={!config.is_admin}
                                            >
                                                <option value="is_internal_backoffice">Backoffice Interno</option>
                                                <option value="is_institute_backoffice">Backoffice Istituto</option>
                                                <option value="is_agency">Agenzia</option>
                                            </Form.Control>
                                        </div>



                                        








                                        
                                    </div>
                                    {   
                                        !config.is_admin ?  "" :
                                            (
                                                loading ? 
                                                    <Button type="button" disabled><ReactLoading
                                                        className="mx-auto"
                                                        type={"spin"}
                                                        color={"#fefefe"}
                                                        height={24}
                                                        width={24}
                                                    /></Button> 
                                                : 
                                                <Button type="submit">{is_new_product ? PublicStrings.add : PublicStrings.save}</Button>
                                            )

                                    }


                                </Form>
                                )}
                            </Card.Body>
                        </Card>
                        <div className='row'>
                        { !config.is_admin ? "" :  
                            <div hidden={is_new_product} className="col-md-6" style={{ "paddingLeft": "0px" }}>
                                <EnabledUsersOrAgenciesList
                                    enabled_for = {products_enabled_for}
                                    product_id = {product_id}
                                    setEnabledFor = {setProductsEnabledFor}
                                    all_products = {all_products}
                                    item_type = 'product'
                                ></EnabledUsersOrAgenciesList>
                            </div> 
                          
                        }

                        { !config.is_admin ? "" :  
                            <div hidden={is_new_product} className="col-md-6" style={{ "paddingLeft": "0px" }}>
                                <EnabledUsersOrAgenciesList
                                    enabled_for = {campaigns_enabled_for}
                                    product_id = {product_id}
                                    setEnabledFor = {setCampaignsEnabledFor}
                                    all_products = {all_campaigns}
                                    item_type = 'campaign'
                                ></EnabledUsersOrAgenciesList>
                            </div> 
                          
                        }
                        </div>
                        
                    </Col>
                </Row>
            </Container>
        </>
    )
}
export default AgencyAddOrView;